/**
 * CategoryTabs Component
 *
 * Horizontal tabs or button group for filtering inventory items by category.
 * Shows item counts per category.
 *
 * User Story: US-P6-001 - Inventory Management
 * Step 2: Inventory Items Management
 */

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'

/**
 * Category display labels
 */
const CATEGORY_LABELS = {
  all: 'All',
  raw_material: 'Raw Materials',
  packaging: 'Packaging',
  sundry: 'Sundry',
  other: 'Other',
}

/**
 * CategoryTabs Component
 *
 * @param {Object} props
 * @param {string} props.value - Current selected category
 * @param {Function} props.onValueChange - Callback when category changes
 * @param {Object} props.counts - Object with category counts { all: 10, raw_material: 5, ... }
 * @param {string} props.className - Additional CSS classes
 */
export default function CategoryTabs({
  value = 'all',
  onValueChange,
  counts = {},
  className = '',
}) {
  const categories = ['all', 'raw_material', 'packaging', 'sundry', 'other']

  return (
    <Tabs value={value} onValueChange={onValueChange} className={className}>
      <TabsList>
        {categories.map((category) => (
          <TabsTrigger key={category} value={category}>
            {CATEGORY_LABELS[category]} ({counts[category] ?? 0})
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}

/**
 * Get the display label for a category
 *
 * @param {string} category - Category key
 * @returns {string} - Display label
 */
export function getCategoryLabel(category) {
  return CATEGORY_LABELS[category] || category
}
